export enum Types {
	CONSULTAR_MOTIVOS = '@SGU/CONSULTAR_MOTIVOS',
	CONSULTAR_MOTIVOS_SUCCESS = '@SGU/CONSULTAR_MOTIVOS_SUCCESS',
	CONSULTAR_MOTIVOS_FAILURE = '@SGU/CONSULTAR_MOTIVOS_FAILURE',
	CONSULTAR_MOTIVOS_CLEAR = '@SGU/CONSULTAR_MOTIVOS_CLEAR',
}

export interface ConsultarMotivos {
	status: number;
	data: Motivo[];
	totalRegistrosConsulta: number;
}

export interface Motivo {
	id: number;
	codigo: number;
	descricao: string;
}

export interface ConsultarMotivosRequest {
	registroInicial?: number;
	limite?: number;
	page?: number;
	size?: number;
	current?: number;
	id?: number | string;
	codigo?: number | string;
	descricao?: string;
}

export interface ConsultarMotivosNewRequest {
	page?: number;
	size?: number;
	id?: number | string;
	descricao?: string;
	codigo?: number | string;
}
